import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { FaFacebook, FaTwitter, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import supabase from "../../../../supabaseClient"; // Adjust path
import "./CustomShareButton.css";

function CustomShareButton({ url, title, description, author, image, date,blogId,content }) {
  const [blog, setBlog] = useState(null);
  const [formattedDate, setFormattedDate] = useState("");

  const fullContent = content || ""; // Ensure content exists


  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: title,
          url: url,
          description: description,
          author: author,
          image: image,
          date: formattedDate,
          content:content
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch((error) => {
          console.log("Sharing failed", error);
        });
    } else {
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(title)}`;
      const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(title)}`;
      const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        url
      )}`;
      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        title
      )}%0A${encodeURIComponent(url)}%0A${encodeURIComponent(formattedDate)}%0A%0A${encodeURIComponent(content)}`;

      window.open(shareUrl, "_blank");
      window.open(twitterUrl, "_blank");
      window.open(linkedinUrl, "_blank");
      window.open(whatsappUrl, "_blank");
    }
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        console.log("Fetching blog with ID:", blogId);

        const { data, error } = await supabase
          .from("blogs")
          .select("*")
          .eq("id", blogId) // Fetch by unique ID
          .single();

        console.log("Supabase response:", { data, error });

        if (error) {
          console.error("Supabase error:", error.message);
          setBlog(null); // Explicitly set an error state
          return;
        }

        setBlog(data);

        // Format the blog's date
        const parsedDate = new Date(data.date);
        const formatted = parsedDate.toLocaleDateString("en-GB", {
          month: "long",
          day: "2-digit",
        });
        setFormattedDate(formatted);
      } catch (err) {
        console.error("Unexpected error:", err.message);
        setBlog(null); // Handle unexpected errors
      }
    };

    fetchBlog();
  }, [blogId]);

  if (blog === null) {
    return <p>Error loading blog content. Please try again later.</p>;
  }

  if (!blog) {
    return <p>Loading blog content...</p>;
  }

  return (
    <Card className="share-card">
      <Card.Img variant="top" src={blog.thumbnail} alt={blog.title} />
      <Card.Body>
        <Card.Title>{blog.title}</Card.Title>
        <Card.Text>{formattedDate}</Card.Text>
        <div className="share-icons">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              url
            )}%0A${encodeURIComponent(title)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="m-1"
          >
            <FaFacebook size={32} />
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
              blog.url
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="m-1"
          >
            <FaTwitter size={32} />
          </a>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
              url
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="m-1"
          >
            <FaLinkedin size={32} />
          </a>
          <a
          href={`https://api.whatsapp.com/send?text=${encodeURIComponent(title)}%0A${encodeURIComponent(url)}%0A${encodeURIComponent(formattedDate)}%0A%0A${encodeURIComponent(
            fullContent
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="m-1"
        >
          <FaWhatsapp size={32} />
        </a>

        </div>
      </Card.Body>
    </Card>
  );
}

export default CustomShareButton;
